(function() {
  const itemSelector = '.dimensional-weight-item';

  function refresh(item, applyWeight = true) {
    const fields = Array.from(item.querySelectorAll('.dimensional-weight-input'));
    const checkbox = item.querySelector('.use-estimated-weight');
    const output = item.querySelector('.dimensional-weight-estimate');
    const weight = item.querySelector('.weight-field');
    if (!checkbox || !output || !weight) return;

    const valid = fields.length === 3 && fields.every(field =>
      /^\d+(\.\d{1,2})?$/.test(field.value) &&
      Number(field.value) > 0 && Number(field.value) <= 999
    );
    const estimate = valid ? Number((fields.reduce((value, field) => value * Number(field.value), 1) / 5000).toFixed(3)) : 0;
    checkbox.disabled = !valid || estimate <= 0;
    output.textContent = valid ? '(Est ' + estimate + 'kg)' : '';
    if (checkbox.disabled) checkbox.checked = false;

    weight.readOnly = checkbox.checked;
    if (checkbox.checked && applyWeight) {
      weight.value = String(estimate);
      weight.dispatchEvent(new Event('input', { bubbles: true }));
      weight.dispatchEvent(new Event('change', { bubbles: true }));
      // Existing available-weight validation can reject this estimate.
      // Keep the chosen mode even when capacity validation rejects the weight.
    }
  }

  document.addEventListener('input', function(event) {
    if (!event.target.matches('.dimensional-weight-input')) return;
    const item = event.target.closest(itemSelector);
    if (item) refresh(item);
  });
  document.addEventListener('change', function(event) {
    if (!event.target.matches('.use-estimated-weight')) return;
    const item = event.target.closest(itemSelector);
    if (item) refresh(item);
  });
  // Estimated mode stays selected until the sender unchecks it.
  document.addEventListener('click', function(event) {
    const control = event.target.closest('.plus, .minus');
    const item = control && control.closest(itemSelector);
    if (item && item.querySelector('.use-estimated-weight').checked) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  function initialize(root) {
    if (root.matches && root.matches(itemSelector)) refresh(root, false);
    if (root.querySelectorAll) root.querySelectorAll(itemSelector).forEach(item => refresh(item, false));
  }
  document.addEventListener('turbolinks:load', function() { initialize(document); });
  document.addEventListener('DOMContentLoaded', function() { initialize(document); });
  new MutationObserver(function(records) {
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType === 1) initialize(node);
    }));
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
